<template>
  <div id="extra-component-form-validation-demo">

    <p class="mb-4"><a href="#" rel="nofollow">Geofence Mapping</a> Page to Mapping Vehicle with Geofence</p>

    <List></List>
  </div>
</template>

<script>

import List from "./MappingGeofenceList.vue"

export default {
  components: {
    List
  }
}
</script>
